import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "../../../../core/helpers/message-helper";
import { Row, Col, Card, CardBody } from "reactstrap";
import { obtenerRecursos } from "../../services/reservas-service";
import { API_DOMAIN } from "../../../../core/config/env";

const RECURSO_CARD_STYLE = {
    verticalAlign: "middle",
    WebkitTransform: "perspective(1px) translateZ(0)",
    transform: "perspective(1px) translateZ(0)",
    boxShadow: "0 0 1px rgb(0 0 0 / 0%)",
    WebkitTransitionDuration: "0.3s",
    transitionDuration: "0.3s",
    WebkitTransitionProperty: "transform",
    transitionProperty: "transform",
    cursor: "pointer",
    margin: "10px",
    width: "100%",
    minHeight: "120px",
};

function SeleccionRecurso() {
    const navigate = useNavigate();
    const [recursos, setRecursos] = useState([]);
    const { setRecursoId, sedeId } = useOutletContext();

    function onClickRecurso(recurso) {
        setRecursoId(recurso.id);
        navigate("/reservas/reservar");
    }

    useEffect(() => {
        if (sedeId == null) return navigate("/reservas");
    });

    useEffect(async () => {
        const resp = await obtenerRecursos();
        if (!resp.status) return toast.error(resp.message);
        setRecursos(resp.data);
    }, []);

    return (
        <Row className="d-flex justify-content-center">
            {recursos.map(function (recurso) {
                return (
                    <Col md="4" className="mb-4" key={recurso.id}>
                        <Card
                            style={RECURSO_CARD_STYLE}
                            className="border-left-primary shadow h-100 hvr-grow"
                            onClick={() => onClickRecurso(recurso)}
                        >
                            <CardBody>
                                <div className="row">
                                    <div className="col-8 d-flex align-items-center flex-column">
                                        <p className="h4 font-weight-bold text-primary text-uppercase mb-2 text-left">
                                            {recurso.nombre}
                                        </p>
                                    </div>
                                    <div className="col-4">
                                        <img
                                            className="rounded-circle"
                                            width="80"
                                            height="80"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                    "img/logo_csr_big.png";
                                            }}
                                            alt={`Foto sede ${recurso.nombre}`}
                                            src={`${API_DOMAIN}${recurso.img}`}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
}

export default SeleccionRecurso;
